import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {ROLES} from "@/lib/auth/roles";
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import Reporting from "@/modules/reporting";
import {  mergedReportingDocumentsSchema, ReportingDocumentsSearch
} from "@/types/route-search-schemas";
import {REPORTING_PATH, REPORTING_URL} from "@/utils/urls";

export const Route = createFileRoute(REPORTING_PATH)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): ReportingDocumentsSearch => {
    const tab = String(search.tab ?? 'generate')
    return validateSearchWithDefaults(mergedReportingDocumentsSchema, { tab, ...search })
  },
  loader: () => {
    if (isCurrentPage(REPORTING_URL)) {
      return
    }
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Reporting', path: '#' },
      ],
      children: <div className={'h-10'}></div>
    }
  },
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[]}
        forbiddenFallback={<Unauthorized/>}>
        <Reporting />
      </Authorisation>
    </div>
  )
}
